<main>
  <div
    class="flex flex-column justify-content-center align-items-center px-2 py-5"
  >
    <div class="w-6">
      <h1 class="text-center mb-4">
        @if (!userAuthenticated) {
          <span>Password reset</span>
        }
        @if (userAuthenticated) {
          <span>Password update</span>
        }
      </h1>

      <p-panel>
        <form
          [formGroup]="setPasswordForm"
          (ngSubmit)="onSubmit()"
          class="p-fluid flex flex-column gap-5"
        >
          <p class="mt-4 text-center">
            @if (!userAuthenticated) {
              <span
                >Please enter your new password twice to verify you typed it
                correctly.</span
              >
            }
            @if (userAuthenticated) {
              <span
                >Please enter your old password and new password twice to verify
                you typed it correctly.</span
              >
            }
          </p>

          <!-- Old password -->
          @if (userAuthenticated) {
            <div>
              <p-floatLabel>
                <input
                  pInputText
                  id="old-password"
                  type="password"
                  formControlName="oldPassword"
                  class="w-full"
                  autocomplete="current-password"
                  pTooltip="Please provide your old password"
                  [ngClass]="{
                    'ng-invalid ng-dirty':
                      formErrors ||
                      (setPasswordForm.get('oldPassword')?.invalid &&
                        setPasswordForm.get('oldPassword')?.touched),
                  }"
                />
                <label for="old-password">Old password</label>
              </p-floatLabel>
              @if (formErrors) {
                <div class="mt-1">
                  <small class="error-message">{{ formErrors }}</small>
                </div>
              }
            </div>
          }

          <!-- New password -->
          <div>
            <p-floatLabel>
              <input
                pInputText
                id="password"
                type="password"
                formControlName="password1"
                class="w-full"
                pTooltip="Your new password"
                autocomplete="new-password"
                [ngClass]="{
                  'ng-invalid ng-dirty':
                    setPasswordForm.get('password1')?.invalid &&
                    setPasswordForm.get('password1')?.touched,
                }"
              />
              <label for="password">New password</label>
            </p-floatLabel>
            <small class="text-muted"
              >At least 8 characters. Cannot be entirely numeric or too
              common.</small
            >
            @if (
              setPasswordForm.get("password1")?.invalid &&
              setPasswordForm.get("password1")?.touched
            ) {
              <div class="mt-1">
                <small class="error-message">Password is required</small>
              </div>
            }
          </div>

          <!-- New password confirmation -->
          <div>
            <p-floatLabel>
              <input
                pInputText
                id="password-confirm"
                type="password"
                formControlName="password2"
                class="w-full"
                pTooltip="Re-type your new password"
                [ngClass]="{
                  'ng-invalid ng-dirty':
                    (setPasswordForm.get('password2')?.invalid ||
                      setPasswordForm.errors?.['validPasswordConfirmation']) &&
                    setPasswordForm.get('password2')?.touched,
                }"
              />
              <label for="password-confirm">New password confirmation</label>
            </p-floatLabel>
            <small class="text-muted"
              >Enter the same password as before, for verification.</small
            >
            @if (
              setPasswordForm.errors?.["validPasswordConfirmation"] &&
              setPasswordForm.get("password2")?.touched
            ) {
              <div class="mt-1">
                <small class="error-message">Passwords do not match</small>
              </div>
            }
          </div>

          <!-- Submit -->
          <div class="flex justify-content-center">
            <button
              pButton
              type="submit"
              label="Change my password"
              class="w-6"
              [disabled]="setPasswordForm.invalid"
            ></button>
          </div>

          <!-- Go back -->
          @if (userAuthenticated) {
            <div class="flex justify-content-center">
              <button
                pButton
                type="button"
                label="Go back to profile"
                class="p-button-secondary w-6"
                (click)="goBackToProfile()"
              ></button>
            </div>
          }

          <!-- Note -->
          @if (userAuthenticated) {
            <p class="text-center text-color-secondary text-sm">
              Please note that after changing your password you'll be logged out
              automatically.
            </p>
          }
        </form>
      </p-panel>
    </div>
  </div>
  <p-scrollTop styleClass="scroll-button"></p-scrollTop>
</main>
